export default __webpack_public_path__ + "static/media/power.4a44d71a.png";